import Vue from "vue";
import request from "./config/http.js";
import params from "./config/params.js";

let url = "/web_index";
const apis = {
    getHistoryConfig(data, baseURL) {
        //
        return request({
            url: baseURL + "/web_common/getHistoryConfig",
            method: "get",
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findThesisList(data, baseURL) {
        //
        return request({
            url: baseURL + "/web_thesis/findThesisList",
            method: "get",
            params: data,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findThesisById(articleId, baseURL) {
        //
        return request({
            url: baseURL + "/web_thesis/findThesisById",
            method: "get",
            params: {
                articleId: articleId,
            },
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    getFindWeibo(baseURL) {
        //
        return request({
            url: baseURL + "/web_index/findWeibo",
            method: "get",
            params: {},
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findPeriodical(baseURL) {
        //期刊列表上部
        return request({
            url: baseURL + "/web_index/findPeriodical",
            method: "get",
            params: {},
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },

    findFirstThesisList(params, baseURL) {
        //栏目
        return request({
            url: baseURL + "/web_thesis/findFirstThesisList",
            method: "post",
            isString: true,
            params: {
                articleId: params,
            },
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findSite(data, baseURL) {
        //首页顶部logo + css样式
        return request({
            url: baseURL + "/web_common/findSite",
            method: "post",
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    searchArticleList(data, baseURL) {
        //站内搜索接口
        return request({
            url: baseURL + "/web_index/searchArticleList",
            method: "post",
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    getChannelList(data, baseURL) {
        // 一级栏目列表接口展示栏目列表
        return request({
            url: baseURL + "/web_common/getChannelList",
            method: "post",
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    getChannelTwoList(parentId, baseURL) {
        //二级栏目列表接口
        return request({
            url: baseURL + "/web_common/getChannelTwoList",
            method: "post",
            data: {
                level: 2,
                parentId: parentId,
            },
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findThesisById(data, baseURL) {
        //单条论文展示功能(包含已出版和网络首发)
        return request({
            url: baseURL + "/web_thesis/findThesisById",
            method: "get",
            params: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findArticle(data, baseURL) {
        //网络首发的详情
        return request({
            url: baseURL + "/web_common/findArticle",
            method: "post",
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findArticleList(data, path, baseURL) {
        //网络首发的列表
        return request({
            url: baseURL + path,
            method: "post",
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findPeriodList(data, baseURL) {
        return request({
            url: baseURL + "/web_common/findPeriodList",
            method: "post",
            data: data,
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    getData(type, place, baseURL) {
        //首页投稿按钮
        return request({
            url: baseURL + url + "/" + type,
            method: "post",
            data: {
                place: place,
            },
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    getList(path, pageSize, pageNum, place) {
        return request({
            url: path,
            method: "post",
            data: {
                pageSize: pageSize,
                pageNum: pageNum || 1,
                place: place,
            },
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    findSinglePage(id, baseURL) {
        //单页接口
        return request({
            url: baseURL + "/web_common/findSinglePage",
            method: "post",
            data: {
                bannerId: id,
            },
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
    // 公告资讯列表
    getInfoList(baseURL, e) {
        return request({
            url: baseURL + "/web_index/recommendInfo",
            method: "post",
            data: {
                place: e,
            },
            jsonString: true,
        }).then((resault) => {
            return Promise.resolve(resault.data);
        });
    },
};

export default apis;



// WEBPACK FOOTER //
// ./src/core/api/manage.serve.js